<div class="h-full overflow-hidden">
  <div class="container-vertical-scroll" fuseScrollbar
       *ngIf="(contacts | async).length > 0">
    <c360-chat-roster-contact *ngFor="let contact of (contacts | async)"
                              [contact]="contact"
                              (click)="onClickContact(contact)">
    </c360-chat-roster-contact>
  </div>
</div>